import React from 'react'
import { Button, Card, CardBody } from 'reactstrap'

export default function QuickActions({setDocType}) {
      const generateDocument = type => {
    setDocType(type)
    // Document generation logic would go here
  }
  return (
      <Card className="border-0 shadow-sm mb-4">
              <CardBody className="p-3">
                <h6 className="mb-3 d-flex align-items-center fw-semibold">
                  <i className="bx bx-file me-2"></i>
                  Generate Documents
                </h6>
                <div className="d-grid gap-2">
                  <Button
                    color="outline-primary"
                    onClick={() => generateDocument("quotation")}
                    className="d-flex align-items-center justify-content-between py-2"
                  >
                    <span>Quotation</span>
                    <i className="bx bx-plus"></i>
                  </Button>
                  <Button
                    color="outline-primary"
                    onClick={() => generateDocument("money-receipt")}
                    className="d-flex align-items-center justify-content-between py-2"
                  >
                    <span>Money Receipt</span>
                    <i className="bx bx-plus"></i>
                  </Button>
                  <Button
                    color="outline-primary"
                    onClick={() => generateDocument("delivery-challan")}
                    className="d-flex align-items-center justify-content-between py-2"
                  >
                    <span>Delivery Challan</span>
                    <i className="bx bx-plus"></i>
                  </Button>
                </div>
              </CardBody>
            </Card>
  )
}
